import { render, staticRenderFns } from "./EconomicGroupTable.vue?vue&type=template&id=640ea4da&scoped=true"
import script from "./EconomicGroupTable.vue?vue&type=script&lang=js"
export * from "./EconomicGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ea4da",
  null
  
)

export default component.exports